// Divide each value, which has a resolution of 15M (Resolution.R15M), to be rendered
// on the bar chart by minute increments.

import {
  ServiceGraphosCloudMetricsMetrics,
  ServiceGraphosCloudMetricsRecord,
} from 'src/lib/graphqlTypes/types';

const convertToPerMinuteResolution = (value: number) => value / 15;

export const transformMetricsToMinuteResolution = (
  record: Omit<ServiceGraphosCloudMetricsRecord, 'groupBy'>,
): Omit<ServiceGraphosCloudMetricsRecord, 'groupBy'> => {
  const { metrics } = record ?? {};

  const minuteResolutionMetrics: ServiceGraphosCloudMetricsMetrics = {
    __typename: metrics.__typename,
    responseSize: convertToPerMinuteResolution(metrics.responseSize),
    responseSizeThrottled: convertToPerMinuteResolution(
      metrics.responseSizeThrottled,
    ),
    routerOperations: convertToPerMinuteResolution(metrics.routerOperations),
    routerOperationsThrottled: convertToPerMinuteResolution(
      metrics.routerOperationsThrottled,
    ),
    subgraphFetches: convertToPerMinuteResolution(metrics.subgraphFetches),
    subgraphFetchesThrottled: convertToPerMinuteResolution(
      metrics.subgraphFetchesThrottled,
    ),
  };

  return {
    ...record,
    metrics: minuteResolutionMetrics,
  };
};
